import { Modal, Space, Spin } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import * as VsclientService from 'services/vsclient';
import ThemeContext from 'store/ThemeContext';

function ClientUpdateCheck({ onEnd }) {
  const theme = useContext(ThemeContext);
  const [updateMsg, setUpdateMsg] = useState(null);
  const createMarkup = (value) => {
    return { __html: value };
  };

  useEffect(() => {
    const checkFunc = async () => {
      try {
        await VsclientService.isUpdate();
        // eslint-disable-next-line no-unused-expressions
        !updateMsg && setUpdateMsg('클라이언트 업데이트 중입니다.<br />잠시만 기다려 주십시오.');
      } catch (e) {
        setUpdateMsg(null);
        onEnd?.(true);
      }
      setTimeout(checkFunc, 1000);
    };

    if (theme?.updateCheck) {
      checkFunc();
    }
  }, []);

  return (
    <div>
      {updateMsg && (
        <Modal footer={false} visible title="업데이트 중" width={320}>
          <Space style={{ padding: 16 }} size={16} align="center">
            <Spin spinning style={{ marginTop: 6 }} />
            <span
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={createMarkup(updateMsg)}
            />
          </Space>
        </Modal>
      )}
    </div>
  );
}

export default ClientUpdateCheck;
